"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = function _default(_ref) {
  var dictateState = _ref.dictateState;
  return dictateState;
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfZGVmYXVsdCIsIl9yZWYiLCJkaWN0YXRlU3RhdGUiLCJleHBvcnRzIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3NlbGVjdG9ycy9kaWN0YXRlU3RhdGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBSZWR1eFN0YXRlIH0gZnJvbSAnLi4vdHlwZXMvaW50ZXJuYWwvUmVkdXhTdGF0ZSc7XG5cbmV4cG9ydCBkZWZhdWx0ICh7IGRpY3RhdGVTdGF0ZSB9OiBSZWR1eFN0YXRlKSA9PiBkaWN0YXRlU3RhdGU7XG4iXSwibWFwcGluZ3MiOiI7Ozs7OztlQUVlLFNBQUFBLFNBQUFDLElBQUE7RUFBQSxJQUFHQyxZQUFZLEdBQUFELElBQUEsQ0FBWkMsWUFBWTtFQUFBLE9BQW1CQSxZQUFZO0FBQUE7QUFBQUMsT0FBQSxjQUFBSCxRQUFBIn0=